import { Box, Container, Typography } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import Editor from './components/Editor'
import { useGetSettingsQuery, useUpdateSettingsMutation } from 'api/adminSlice'
import { useTranslation } from 'react-i18next'
import { LoadingButton } from '@mui/lab'
import parse from 'html-react-parser';

export default function TermsAndConditions({ type }) {
    const { t } = useTranslation()
    const [payload, setPayload] = useState({ termsAndConditions: '' })
    const { data: settings, isLoading } = useGetSettingsQuery()
    const [updateSettings, { isLoading: updateLoading, isSuccess, error }] = useUpdateSettingsMutation()

    useEffect(() => {
        if (!!settings?.termsAndConditions) {
            setPayload({ termsAndConditions: settings?.termsAndConditions })
        }
    }, [settings])

    const handleChange = ({ target: { value } }) => {
        setPayload({ termsAndConditions: value })
    }

    const updateSettingsHandler = () => {
        updateSettings(payload)
    }

    const parsedHtml = useMemo(() => {
        if (settings?.termsAndConditions) {
            return parse(settings?.termsAndConditions)
        }
        return ''
    }, [settings])

    const setTransparerntBackground = async () => {
        await new Promise((resolve) => setTimeout(resolve, 700))
        try {
            if (!isLoading) {
                let selectElement = document.getElementById('parsed-html-container');
                // Add 'background: transparent' to the select element
                selectElement.style.background = 'transparent';

                // Now, let's add 'background: transparent' to its childs elements
                let childElements = selectElement?.children;

                for (var i = 0; i < childElements.length; i++) {
                    childElements[i].style.background = 'transparent';
                }

                // Now, let's add 'background: transparent' to its childs span
                let spans = document.getElementById('parsed-html-container').querySelectorAll("span")

                for (var i = 0; i < spans.length; i++) {
                    spans[i].style.background = 'transparent';
                }

                // Now, let's add 'background: transparent' to its parent elements
                let parentElement = selectElement.parentElement;
                while (parentElement != null) {
                    parentElement.style.background = 'transparent';
                    parentElement = parentElement.parentElement;
                }
            }
        } catch (error) {
            console.log("Error: setTransparerntBackground")
            console.log(error)
        }
    }

    useEffect(() => {
        setTransparerntBackground()
    }, [isLoading])

    return (
        <Container sx={{ background: "transparent" }}>
            {type === "EDIT" ?
                <Box>
                    <Editor name="termsAndConditions" description={settings?.termsAndConditions} onChange={handleChange} />
                    <Box display="flex" alignItems="center" justifyContent="space-between" my={20}>
                        <LoadingButton
                            loading={updateLoading}
                            onClick={updateSettingsHandler}
                            variant='contained'
                            sx={{ textTransform: "none" }}
                        >
                            {t("Confirm")}
                        </LoadingButton>
                        {isSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
                        {!!error && <Typography color="error">{t(error)}</Typography>}
                    </Box>
                </Box>
                :
                <Box id="parsed-html-container" pt={70} px={12}>
                    {parsedHtml}
                </Box>
            }
        </Container>
    )
}
